import { render, staticRenderFns } from "./NewAMForgotUserIDAcc.vue?vue&type=template&id=046fd84c&scoped=true"
import script from "./NewAMForgotUserIDAcc.vue?vue&type=script&lang=js"
export * from "./NewAMForgotUserIDAcc.vue?vue&type=script&lang=js"
import style0 from "./NewAMForgotUserIDAcc.vue?vue&type=style&index=0&id=046fd84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046fd84c",
  null
  
)

export default component.exports